import { render, staticRenderFns } from "./BpuTemplateList.vue?vue&type=template&id=3fc272e4&scoped=true"
import script from "./BpuTemplateList.vue?vue&type=script&lang=js"
export * from "./BpuTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc272e4",
  null
  
)

export default component.exports